import React, { useEffect, useState } from "react";
import { Dropdown, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from '../../Services/UserSessionManager';
import { Link, useNavigate } from "react-router-dom";
import './Home.css';
import { EmployeeInfoModal } from "../EmployeeTeamDetail/EmployeeInfomodal";
import { Modal } from "react-bootstrap";
export  const AppProfile=()=>{
    
        const [checkRole,setCheckRole]=useState(userManager.GetUserRole());
        const [checkProductionRole,setProductionCheckRole]=useState(userManager.GetUserProductionRole());


    const[loginid,setLoginid]=useState(userManager.GetUserLoginID());
    const[userName,setUserName]=useState(userManager.GetUserName());
    const[popup,setpopUp]=useState(false);
    const handleClose=()=>setpopUp(false);

    const showPopUp=()=>{
        setpopUp(true); 
    }
    return(
       <>
        {checkRole=='H' || checkRole=='PM'||  checkRole=='BI'||checkRole=='M' ||checkRole=='QM'||checkRole=='A'?
        
        <Dropdown title={"Me"}
        className="nav-bar-text-white"
        icon={<BootstrapIcon cssClasses="p-2 nav-bar-text-white" bootStrapIconName="person-circle" size={18} />}>
      <Modal show={popup} fullscreen={true} onHide={handleClose}>
                <EmployeeInfoModal id={loginid} title={userName} />
                </Modal>
                
            <Dropdown.Item
                icon={<BootstrapIcon bootStrapIconName={"person-fill"} size={14} cssClasses={'pe-2'} />}
                onClick={showPopUp}
            >
                My Details
            </Dropdown.Item>
          
           
                {(checkRole=='M'||checkRole=='A'||checkRole=='PM'||checkRole=='QM') && checkProductionRole!=='Non-Production (Manager)'&& checkProductionRole!=='Non-production (Other)'&&checkProductionRole!=='Non-Production (Lead)'?
              
                <div>
                 <Link className="link-simple" to={'/EntryScreen'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"keyboard-fill"} size={14} cssClasses={'pe-2'} />}
                    >
                        Productivity Entry
                    </Dropdown.Item>
                </Link>
                
               </div>
                :<></>}
             
             
            </Dropdown>
           :  <></> 
     
       } 
      
       </>
    )
}
